import { render, staticRenderFns } from "./bottomRight.vue?vue&type=template&id=953bcf06&scoped=true&"
import script from "./bottomRight.vue?vue&type=script&lang=js&"
export * from "./bottomRight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "953bcf06",
  null
  
)

export default component.exports